import { IAuthentication } from './services/authentication.interface';
// src/app/auth/token.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthenticationService } from './services/authentication.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationTokenInterceptor implements HttpInterceptor {
  constructor(
    public auth: AuthenticationService,
    private router: Router,
  ) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // always get the live value for the current user$
    const user: IAuthentication = this.auth.user$.getValue();

    // If the user is logged in, automagically inject a token to an outbound request with their
    // authenticated token regardless of what route they are calling
    if (
      user &&
      user.loggedIn &&
      user.token &&
      !request.headers.has('Authorization') &&
      !request.url.includes('amazonaws.com')
    ) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.token}`,
        },
      });
    }

    // error handling to redirect them to login if we encounter a 401 with a return url optional
    // so they can be taken back to this specific page that made the API call
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // user doesn't have access to marketplace
        if (error.status === 401 && !user.jwt) {
          this.router.navigate(['/auth/401']);
        }
        // user does have access but their token expired
        if (error.status === 401 && user.jwt) {
          this.auth.logout().subscribe(() => {
            this.router.navigate(['/auth/logout'], {
              queryParams: { isExpired: true },
            });
          });
        }

        // throw all non 401 errors back up for whatever upstream service calling this to handle, in this
        // auth context we only care about dealing with a 401
        return throwError(error);
      }),
    );
  }
}
